@if (initialized) {
    <div class="surface-card p-3 border-round">
        <div class="flex align-items-center justify-content-between gap-2 mb-3">
            <div class="flex align-items-center gap-2">
                <i class="fa-regular fa-database text-primary"></i>
                <span class="text-lg font-medium">EI-Import-Fortschritt</span>
            </div>
            @if (eiImportId) {
                <p-button
                        label="EI-Import öffnen"
                        icon="fa-regular fa-arrow-up-right-from-square"
                        severity="secondary"
                        [text]="true"
                        (onClick)="handleOpenEiImport()">
                </p-button>
            }
        </div>

        <!-- Kein EI-Import verknüpft -->
        @if (!eiImportId) {
            <div class="p-3 border-round surface-100 flex align-items-center gap-2">
                <i class="fa-regular fa-circle-info text-color-secondary"></i>
                <span class="text-color-secondary">Kein EI-Import verknüpft.</span>
            </div>
        } @else if (loading) {
            <!-- Ladezustand -->
            <div class="grid">
                <div class="col-12 md:col-6">
                    <p-skeleton width="100%" height="2rem"></p-skeleton>
                </div>
                <div class="col-12 md:col-6">
                    <p-skeleton width="100%" height="2rem"></p-skeleton>
                </div>
                <div class="col-12 md:col-6">
                    <p-skeleton width="100%" height="2rem"></p-skeleton>
                </div>
                <div class="col-12 md:col-6">
                    <p-skeleton width="100%" height="2rem"></p-skeleton>
                </div>
            </div>
        } @else if (loadError) {
            <!-- Ladefehler -->
            <div class="p-3 border-round surface-100 flex align-items-center gap-2">
                <i class="fa-regular fa-triangle-exclamation text-red-500"></i>
                <span class="text-color-secondary">Die EI-Import-Daten konnten nicht geladen werden.</span>
            </div>
        } @else if (eiImport) {
            <!-- Erfolgreich geladen -->
            <div class="flex flex-column gap-3">

                <!-- Phase -->
                <!-- @ticket TM-1000001829 — render German phase uiLabel instead of the raw ordinal. -->
                @if (eiImport.phase !== undefined && eiImport.phase !== null) {
                    <div class="flex align-items-center gap-2">
                        <span class="text-sm text-color-secondary">Phase:</span>
                        <p-tag severity="info" [value]="getEiImportPhaseLabel(eiImport.phase)"></p-tag>
                    </div>
                }

                <!-- Gesamtanzahl Datensätze -->
                @if (eiImport.recordCount !== undefined && eiImport.recordCount !== null) {
                    <div class="flex align-items-center gap-2">
                        <span class="text-sm text-color-secondary">Datensätze gesamt:</span>
                        <span class="font-medium">{{ eiImport.recordCount }}</span>
                    </div>
                }

                <!-- Counters -->
                <div class="grid">
                    <div class="col-12 md:col-6 lg:col-3">
                        <div class="surface-100 p-3 border-round flex flex-column gap-2 align-items-center">
                            <i class="fa-regular fa-circle-plus text-green-500 text-xl"></i>
                            <span class="text-sm text-color-secondary">Erstellte Datensätze</span>
                            <span class="text-xl font-medium">{{ eiImport.recordsCreated ?? 0 }}</span>
                        </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-3">
                        <div class="surface-100 p-3 border-round flex flex-column gap-2 align-items-center">
                            <i class="fa-regular fa-pen-to-square text-blue-500 text-xl"></i>
                            <span class="text-sm text-color-secondary">Aktualisierte Datensätze</span>
                            <span class="text-xl font-medium">{{ eiImport.recordsUpdated ?? 0 }}</span>
                        </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-3">
                        <div class="surface-100 p-3 border-round flex flex-column gap-2 align-items-center">
                            <i class="fa-regular fa-forward text-orange-500 text-xl"></i>
                            <span class="text-sm text-color-secondary">Übersprungene Datensätze</span>
                            <span class="text-xl font-medium">{{ eiImport.recordsSkipped ?? 0 }}</span>
                        </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-3">
                        <div class="surface-100 p-3 border-round flex flex-column gap-2 align-items-center">
                            <i class="fa-regular fa-triangle-exclamation text-red-500 text-xl"></i>
                            <span class="text-sm text-color-secondary">Fehlerhaft</span>
                            <span class="text-xl font-medium">{{ eiImport.recordsErrors ?? 0 }}</span>
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
}
